export default __webpack_public_path__ + "static/media/blog-39-4.5aa0ce0d.png";